import React, { FunctionComponent, useMemo } from "react";
import { FeatureCollection } from "geojson";

import MapStyleCustomisation from "@alpaca-travel/react-mapbox-gl/map-style-customisation";
import useAmpolServiceDataStore from "@/use-ampol-service-data-store";
import { GeoJSONSource } from "mapbox-gl";
import { AmpolService } from "@/types";

const StoreLocations: FunctionComponent<StoreLocationsProps> = () => {
  const ampolServices = useAmpolServiceDataStore((state) => state.services);

  const geoJson: FeatureCollection = useMemo(() => {
    const services = ampolServices ?? new Map<string, AmpolService>();

    return {
      type: "FeatureCollection",
      features: Array.from(services.values()).map((service) => {
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: service.position,
          },
          properties: {
            $id: service.$id,
            name: service.name,
          },
        };
      }),
    };
  }, [ampolServices]);

  return (
    <MapStyleCustomisation
      customisations={[
        {
          type: "AddSource",
          id: "ampol",
          source: {
            type: "geojson",
            data: geoJson,
          } as any as GeoJSONSource,
        },
        {
          type: "AddLayer",
          layer: {
            id: "ampol-services",
            type: "circle",
            source: "ampol",
            paint: {
              "circle-radius": 4,
              "circle-stroke-width": 2,
              "circle-stroke-color": "#FFF",
              "circle-color": "#333",
            },
          },
        },
      ]}
    />
  );
};

export type StoreLocationsProps = {};

export default React.memo(StoreLocations);
